//@ts-nocheck
import './style.css';
import './svg-controls.css';
import { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import React from 'react';
import { ReactComponent as Doctor } from '../../../../../assets/img/pharmacy/DOCTOR.svg';
import { ReactComponent as MedicalCommission } from '../../../../../assets/img/pharmacy/medicalCommission.svg';
import { ReactComponent as Recipe } from '../../../../../assets/img/pharmacy/recipe.svg';
import { ReactComponent as Stamp } from '../../../../../assets/img/pharmacy/stamp.svg';
import { ReactComponent as Stamp1 } from '../../../../../assets/img/pharmacy/Stamp1.svg';
import { ReactComponent as Stamp2 } from '../../../../../assets/img/pharmacy/Stamp2.svg';
import { ReactComponent as Stamp4 } from '../../../../../assets/img/pharmacy/Stamp4.svg';
import { ReactComponent as Special1 } from '../../../../../assets/img/pharmacy/Special1.svg';
import { ReactComponent as Special2 } from '../../../../../assets/img/pharmacy/Special2.svg';
import { ReactComponent as Special5 } from '../../../../../assets/img/pharmacy/Special5.svg';
import { ReactComponent as Recipe1 } from '../../../../../assets/img/pharmacy/Recipe1.svg';
import { ReactComponent as Doctor1 } from '../../../../../assets/img/pharmacy/Doctor1.svg';

interface Form107_1Props {
  onInputChange?: (id: number, value: string) => void;
  initialValues: InitialValuesType;
  onCheckboxStateChange?: (inputCheckboxStates: {
    inputs: { [key: number]: boolean };
    svgs: { [key: number]: boolean };
  }) => void;
  isShow?: boolean;
  isReadOnly?: boolean;
  isShowDeleteButton?: boolean;
  formDroppedItems?: SvgType[];
  handleDragStart?: (index: number, type: string) => void;
  handleDragOver?: () => void;
  handleDrop?: (event: React.DragEvent<HTMLDivElement>) => void;
  onSvgDelete?: (index: number, id: number) => void;
  isConstructor?: boolean;
  isChatPage?: boolean;
  isPharmacyModal?: boolean;
  userValidityInput?: string;
  onUserValidityInputChange?: (input: string) => void;
}

interface InitialValuesType {
  inputs?: {
    [key: number]: {
      value: string | undefined;
      right?: boolean;
      [key: string]: any;
    };
  };
  svgs?: Array<SvgType>;
}

interface SvgType {
  id: number;
  type: string;
  x: number;
  y: number;
  isWrongAnswer: boolean;
}

const Form107_1 = forwardRef(({
  initialValues,
  onInputChange,
  formDroppedItems = [],
  handleDragStart,
  handleDragOver,
  handleDrop,
  onSvgDelete,
  isShow,
  isReadOnly,
  onCheckboxStateChange,
  isConstructor,
  isChatPage,
  isPharmacyModal,
  userValidityInput,
  onUserValidityInputChange
}: Form107_1Props, ref) => {
  const [inputCheckboxStates, setInputCheckboxStates] = useState<{ [key: number]: boolean }>(() => {
    console.log('Initializing inputCheckboxStates with:', initialValues?.inputs);
    let initialCheckboxStates = {};
    
    if (initialValues?.inputs) {
      initialCheckboxStates = Object.fromEntries(
        Object.entries(initialValues.inputs).map(([id, input]) => [
          Number(id),
          input.right || false,
        ])
      );
      
      // Специальная обработка для cell: 20 (данные срока действия)
      if (initialValues.inputs[20] && initialValues.inputs[20].value) {
        const periodValue = initialValues.inputs[20].value;
        const periodMapping = { '30': 17, '60': 18, '365': 19 };
        const periodId = periodMapping[periodValue];
        
        if (periodId) {
          // Устанавливаем подчеркивание для соответствующего периода
          initialCheckboxStates[periodId] = true;
          // Снимаем остальные периоды
          Object.values(periodMapping).forEach(id => {
            if (id !== periodId) {
              initialCheckboxStates[id] = false;
            }
          });
          // Устанавливаем состояние чекбокса правильности
          initialCheckboxStates[20] = initialValues.inputs[20].right || false;
        }
      }
    }
    
    console.log('Initial inputCheckboxStates:', initialCheckboxStates);
    return initialCheckboxStates;
  });

  const [svgCheckboxStates, setSvgCheckboxStates] = useState<{ [key: number]: boolean }>(() => {
    console.log('Initializing svgCheckboxStates with:', initialValues?.svgs);
    const initialSvgCheckboxStates = initialValues?.svgs
      ? Object.fromEntries(
          initialValues.svgs.map((svg) => [svg.id, svg.isWrongAnswer || false])
        )
      : {};
    console.log('Initial svgCheckboxStates:', initialSvgCheckboxStates);
    return initialSvgCheckboxStates;
  });

  const [values, setValues] = useState<InitialValuesType>(initialValues);

  useEffect(() => {
    setValues((prevValues) => ({
      inputs: {
        ...prevValues.inputs,
        ...initialValues.inputs,
      },
    }));
  }, [initialValues.inputs]);

  const resetAllFields = () => {
    setValues({ inputs: {} });
    setInputCheckboxStates({});
    setSvgCheckboxStates({});
  };

  useImperativeHandle(ref, () => ({
    resetAllFields,
  }));

  const handleInputChangeLocal = (id: number, value: string) => {
    setValues((prev) => ({
      ...prev,
      inputs: {
        ...prev.inputs,
        [id]: {
          ...(prev.inputs?.[id] || {}),
          value,
        },
      },
    }));
    onInputChange?.(id, value);
  };

  const handleInputCheckboxChange = (id: number) => {
    setInputCheckboxStates((prev) => {
      const newState = { ...prev, [id]: !prev[id] };

      setValues((prevValues) => {
        const newInputData = {
          ...prevValues,
          inputs: {
            ...prevValues.inputs,
            [id]: {
              ...(prevValues.inputs?.[id] || {}),
              right: newState[id],
              value: id === 20 ? (prevValues.inputs?.[id]?.value || '') : (prevValues.inputs?.[id]?.value || undefined),
            },
          },
        };
        
        return newInputData;
      });

      onCheckboxStateChange?.({ inputs: newState, svgs: svgCheckboxStates });
      return newState;
    });
  };

  const handleSvgCheckboxChange = (id: number) => {
    setSvgCheckboxStates((prev) => {
      const newState = { ...prev, [id]: !prev[id] };

      onCheckboxStateChange?.({ inputs: inputCheckboxStates, svgs: newState });
      return newState;
    });
  };

  const handleValidityPeriodChange = (period: '30' | '60' | '1year') => {
    // В конструкторе должно работать редактирование, даже если isReadOnly undefined
    if (isReadOnly && !isConstructor) return;
    
    const periodIds = { '30': 17, '60': 18, '1year': 19 };
    const periodValues = { '30': '30', '60': '60', '1year': '365' };
    const selectedId = periodIds[period];
    const selectedValue = periodValues[period];
    
    const isCurrentlySelected = inputCheckboxStates[selectedId];
    
    onUserValidityInputChange?.(isCurrentlySelected ? '' : selectedValue);
    
    const newCheckboxState = { ...inputCheckboxStates };
    
    newCheckboxState[17] = false;
    newCheckboxState[18] = false;
    newCheckboxState[19] = false;
    
    if (!isCurrentlySelected) {
      newCheckboxState[selectedId] = true;
    } else {
      newCheckboxState[20] = false;
    }
    
    setInputCheckboxStates(newCheckboxState);
    
    setValues((prevValues) => {
      const newInputs = { ...prevValues.inputs };
      
      delete newInputs[17];
      delete newInputs[18];
      delete newInputs[19];
      
      if (!isCurrentlySelected) {
        newInputs[20] = {
          ...(newInputs[20] || {}),
          value: selectedValue,
          right: newInputs[20]?.right || false
        };
        
        onInputChange?.(20, selectedValue);
      } else {
        delete newInputs[20];
      }
      
      return { ...prevValues, inputs: newInputs };
    });
    
    onCheckboxStateChange?.({ inputs: newCheckboxState, svgs: svgCheckboxStates });
  };

  const getSvgStyle = (type: string, x: number, y: number) => {
    const baseStyle = {
      position: 'absolute' as const,
      cursor: 'move'
    };

    switch (type) {
      case 'Doctor':
        return {
          ...baseStyle,
          left: `${x - 150}px`,
          top: `${y - 40}px`,
          transform: 'scale(1)',
        };
      case 'MedicalCommission':
        return {
          ...baseStyle,
          left: `${x + 45}px`,
          top: `${y + 145}px`,
          transform: 'scale(1.1)',
        };
      case 'Recipe':
        return {
          ...baseStyle,
          left: `${x + 40}px`,
          top: `${y + 100}px`,
          transform: 'scale(1)',
        };
      case 'Stamp':
        return {
          ...baseStyle,
          left: `${x - 230}px`,
          top: `${y + 60}px`,
          transform: 'scale(1.2)',
        };
      case 'Stamp1':
        return {
          ...baseStyle,
          left: `${x - 190}px`,
          top: `${y + 45}px`,
          transform: 'scale(1)',
        };
      case 'Stamp2':
        return {
          ...baseStyle,
          left: `${x - 140}px`,
          top: `${y - 48}px`,
          transform: 'scale(1.3)',
        };
      case 'Stamp4':
        return {
          ...baseStyle,
          left: `${x - 165}px`,
          top: `${y + 45}px`,
          transform: 'scale(0.5)',
        };
      case 'Special1':
        return {
          ...baseStyle,
          left: `${x - 240}px`,
          top: `${y + 110}px`,
          transform: 'scale(0.6)',
        };
      case 'Special2':
        return {
          ...baseStyle,
          left: `${x + 25}px`,
          top: `${y + 100}px`,
          transform: 'scale(0.75)',
        };
      case 'Special5':
        return {
          ...baseStyle,
          left: `${x + 5}px`,
          top: `${y + 75}px`,
          transform: 'scale(0.5)',
        };
      case 'Recipe1':
        return {
          ...baseStyle,
          left: `${x + 55}px`,
          top: `${y - 30}px`,
          transform: 'scale(1.3)',
        };
      case 'Doctor1':
        return {
          ...baseStyle,
          left: `${x + 90}px`,
          top: `${y - 90}px`,
          transform: 'scale(1.1)',
        };
      default:
        return {
          ...baseStyle,
          left: `${x}px`,
          top: `${y}px`,
          transform: 'scale(2)',
        };
    }
  };

  return (
    <div
      style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px',
        position: 'relative',
        border: '1px solid rgba(34, 34, 34, 0.31)'
      }}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {/* SVG элементы */}
      {[...initialValues.svgs || [], ...formDroppedItems].map((svg, index) => (
        <div
          key={`svg-${svg.id}-${index}`}
          className="svg-wrapper"
          style={getSvgStyle(svg.type, svg.x, svg.y)}
          draggable={isConstructor}
          onDragStart={() => handleDragStart?.(index, 'response')}
        >
          {svg.type === 'Doctor' && <Doctor />}
          {svg.type === 'MedicalCommission' && <MedicalCommission />}
          {svg.type === 'Recipe' && <Recipe />}
          {svg.type === 'Stamp' && <Stamp />}
          {svg.type === 'Stamp1' && <Stamp1 />}
          {svg.type === 'Stamp2' && <Stamp2 />}
          {svg.type === 'Stamp4' && <Stamp4 />}
          {svg.type === 'Special1' && <Special1 />}
          {svg.type === 'Special2' && <Special2 />}
          {svg.type === 'Special5' && <Special5 />}
          {svg.type === 'Recipe1' && <Recipe1 />}
          {svg.type === 'Doctor1' && <Doctor1 />}
          <div className="svg-controls">
            {isShow && (
              <input
                type="checkbox"
                className="svg-checkbox"
                checked={svgCheckboxStates[svg.id] || false}
                onChange={() => handleSvgCheckboxChange(svg.id)}
              />
            )}
            {isConstructor && (
              <button
                className="svg-delete-button"
                onClick={() => onSvgDelete?.(index, svg.id)}
              >
                ×
              </button>
            )}
          </div>
        </div>
      ))}

      {/* Шапка формы */}
      <div style={{ margin: '0 auto', marginBottom: 20 }}>
        <div className="header" style={{ textAlign: 'right', marginBottom: '20px', lineHeight: 1.2 }}>
          <p>Приложение № 2</p>
          <p>Министерство здравоохранения Российской Федерации</p>
          <p>к приказу Министерства здравоохранения </p>
          <p>Российской Федерации</p>
          <p>от 24 ноября 2021 г. N 1094н</p>
        </div>
        <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 500, marginBottom: 8 }}>
          ФОРМА РЕЦЕПТУРНОГО БЛАНКА N 107-1/У
        </div>
        <table style={{ borderCollapse: 'collapse', fontSize: '16px', marginBottom: 0, maxWidth: 900, display: 'block', margin: '0 auto' }}>
          <tbody>
            <tr>
              <td style={{ border: '1px solid #888', padding: 6, width: '40%', verticalAlign: 'top' }}>
                Министерство здравоохранения<br />Российской Федерации
              </td>
              <td style={{ border: '1px solid #888', padding: 6, width: '30%', verticalAlign: 'top' }}>
                Код формы по ОКУД<br />
                Код учреждения по ОКПО
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: '1px solid #888', padding: 6, textAlign: 'center' }}>
                Медицинская документация
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #888', padding: 6, verticalAlign: 'top' }}>
                Наименование (штамп)<br />медицинской организации
              </td>
              <td style={{ border: '1px solid #888', padding: 6, verticalAlign: 'top' }} rowSpan={2}>
                <div>Форма N 107-1/у</div>
                <div>Утверждена приказом<br />Министерства здравоохранения<br />Российской Федерации<br />от 24 ноября 2021 г. N 1094н</div>
              </td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #888', padding: 6, verticalAlign: 'top' }}>
                Наименование (штамп)<br />индивидуального предпринимателя<br />
                <span style={{ fontSize: '13px' }}>(указать адрес, номер и дату лицензии, наименование органа государственной власти, выдавшего лицензию)</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ borderBottom: '2px dashed #222', marginTop: 8 }} />

      {/* Рецепт */}
      <div style={{ margin: '20px 0' }}>
        <h3 style={{ textAlign: 'center' }}>РЕЦЕПТ</h3>
        <div style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14pt' }}>
          <span>(</span>
          <span 
            style={{ 
              textDecoration: values.inputs?.[16]?.value === 'adult' ? 'underline' : 'none',
              textDecorationThickness: '2px',
              textDecorationColor: '#000',
              textUnderlineOffset: '2px',
              cursor: 'pointer',
            }}
            onClick={() => !isReadOnly && handleInputChangeLocal(16, 'adult')}
          >
            взрослый
          </span>
          <span>, </span>
          <span 
            style={{ 
              textDecoration: values.inputs?.[16]?.value === 'child' ? 'underline' : 'none',
              textDecorationThickness: '2px',
              textDecorationColor: '#000',
              textUnderlineOffset: '2px',
              cursor: 'pointer',
              padding: '0px 4px',
            }}
            onClick={() => !isReadOnly && handleInputChangeLocal(16, 'child')}
          >
            детский
          </span>
          <span> - нужное подчеркнуть)</span>
          {isShow && (
            <input
              id="checkbox-16"
              type="checkbox"
              checked={inputCheckboxStates[16] || false}
              onChange={() => handleInputCheckboxChange(16)}
            />
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', marginBottom: '10px' }}>
          <span>"</span>
          <input
            type="text"
            style={{ width: '30px', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', textAlign: 'center', fontSize: '14pt' }}
            value={values.inputs?.[5]?.value ?? ''}
            onChange={e => {
              const val = e.target.value.replace(/\\D/g, '').slice(0, 2);
              handleInputChangeLocal(5, val);
            }}
            disabled={isReadOnly}
          />
          <span>"</span>
          <input
            type="text"
            style={{ width: '120px', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', textAlign: 'center', fontSize: '14pt' }}
            value={values.inputs?.[6]?.value ?? ''}
            onChange={(e) => {
              const val = e.target.value.slice(0, 8);
              handleInputChangeLocal(6, val);
            }}
            disabled={isReadOnly}
          />
          <span>20</span>
          <input
            type="text"
            style={{ width: '30px', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', textAlign: 'center', fontSize: '14pt' }}
            value={values.inputs?.[7]?.value ?? ''}
            onChange={e => {
              const val = e.target.value.replace(/\\D/g, '').slice(0, 2);
              handleInputChangeLocal(7, val);
            }}
            disabled={isReadOnly}
          />
          <span>г.</span>
          {isShow && (
            <input
              type="checkbox"
              checked={inputCheckboxStates[7] || false}
              onChange={() => handleInputCheckboxChange(7)}
            />
          )}
        </div>

        {/* ФИО пациента */}
        <div style={{ margin: '10px 0' }}>
          <label>Фамилия, инициалы имени и отчества (последнее - при наличии) пациента</label>
          <input
            type="text"
            style={{ width: '95%', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', height: 25, fontSize: '14pt' }}
            value={values.inputs?.[8]?.value ?? ''}
            onChange={(e) => handleInputChangeLocal(8, e.target.value)}
            disabled={isReadOnly}
          />
          {isShow && (
            <input
              type="checkbox"
              checked={inputCheckboxStates[8] || false}
              onChange={() => handleInputCheckboxChange(8)}
            />
          )}
        </div>

        {/* Дата рождения */}
        <div style={{ margin: '10px 0' }}>
          <label>Дата рождения</label>
          <input
            type="text"
            style={{ width: '95%', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', height: 25, fontSize: '14pt' }}
            value={values.inputs?.[9]?.value ?? ''}
            onChange={(e) => handleInputChangeLocal(9, e.target.value)}
            disabled={isReadOnly}
          />
          {isShow && (
            <input
              type="checkbox"
              checked={inputCheckboxStates[9] || false}
              onChange={() => handleInputCheckboxChange(9)}
            />
          )}
        </div>

        {/* ФИО врача */}
        <div style={{ margin: '10px 0' }}>
          <label>Фамилия, инициалы имени и отчества (последнее - при наличии) лечащего врача (фельдшера, акушерки)</label>
          <input
            type="text"
            style={{ width: '95%', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', height: 25, fontSize: '14pt' }}
            value={values.inputs?.[10]?.value ?? ''}
            onChange={(e) => handleInputChangeLocal(10, e.target.value)}
            disabled={isReadOnly}
          />
          {isShow && (
            <input
              type="checkbox"
              checked={inputCheckboxStates[10] || false}
              onChange={() => handleInputCheckboxChange(10)}
            />
          )}
        </div>

        {/* Таблица Rp */}
        <table style={{ width: '95%%', margin: '20px 0', borderCollapse: 'collapse' }}>
          <tbody>
            {/* Первый рецепт */}
            <tr>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px', width: '10%' }}>руб.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px', width: '10%' }}>коп.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px', width: '10%' }}>Rp.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px', width: '70%' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <input
                    type="text"
                    style={{ width: '95%', resize: 'none', height: 25, fontSize: '14pt', border: 'none', borderBottom: '1px solid #000' }}
                    value={values.inputs?.[11]?.value ?? ''}
                    onChange={(e) => handleInputChangeLocal(11, e.target.value)}
                    disabled={isReadOnly}
                  />
                  {isShow && (
                    <input
                      type="checkbox"
                      checked={inputCheckboxStates[11] || false}
                      onChange={() => handleInputCheckboxChange(11)}
                      style={{ marginLeft: '5px' }}
                    />
                  )}
                </div>
              </td>
            </tr>

            {/* Второй рецепт */}
            <tr>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>руб.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>коп.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>Rp.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <input
                    type="text"
                    style={{ width: '95%', resize: 'none', height: 25, fontSize: '14pt', border: 'none', borderBottom: '1px solid #000' }}
                    value={values.inputs?.[12]?.value ?? ''}
                    onChange={(e) => handleInputChangeLocal(12, e.target.value)}
                    disabled={isReadOnly}
                  />
                  {isShow && (
                    <input
                      type="checkbox"
                      checked={inputCheckboxStates[12] || false}
                      onChange={() => handleInputCheckboxChange(12)}
                      style={{ marginLeft: '5px' }}
                    />
                  )}
                </div>
              </td>
            </tr>

            {/* Третий рецепт */}
            <tr>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>руб.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>коп.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>Rp.</td>
              <td style={{ verticalAlign: 'bottom', padding: '0 5px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <input
                    type="text"
                    style={{ width: '95%', resize: 'none', height: 25, fontSize: '14pt', border: 'none', borderBottom: '1px solid #000' }}
                    value={values.inputs?.[13]?.value ?? ''}
                    onChange={(e) => handleInputChangeLocal(13, e.target.value)}
                    disabled={isReadOnly}
                  />
                  {isShow && (
                    <input
                      type="checkbox"
                      checked={inputCheckboxStates[13] || false}
                      onChange={() => handleInputCheckboxChange(13)}
                      style={{ marginLeft: '5px' }}
                    />
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Подпись и печать */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '97%' }}>
            <p>Подпись и печать лечащего врача (подпись фельдшера, акушерки)</p>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <input
                type="text"
                style={{ width: '95%', borderBottom: '1px solid #000', borderTop: 'none', borderLeft: 'none', borderRight: 'none', height: 25, fontSize: '14pt' }}
                value={values.inputs?.[14]?.value ?? ''}
                onChange={(e) => handleInputChangeLocal(14, e.target.value)}
                disabled={isReadOnly}
              />
              <p>М.П.</p>
              {isShow && (
                <input
                  type="checkbox"
                  checked={inputCheckboxStates[14] || false}
                  onChange={() => handleInputCheckboxChange(14)}
                />
              )}

            </div>
          </div>
        </div>
        {/* Срок действия */}
          <div style={{ textAlign: 'left', marginTop: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '97%' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row', width: '60%' }}>
                <p style={{ fontSize: '10pt', alignSelf: 'center', marginRight: '5px' }}>Рецепт действителен</p>
                
                {(() => {
                  // Для студентов (режим чтения) показываем только выбранный преподавателем период
                  if (isReadOnly && (isChatPage || !isConstructor)) {
                    const selectedPeriodData = initialValues.inputs?.[20];
                    if (selectedPeriodData && selectedPeriodData.value) {
                      const periodValue = selectedPeriodData.value;
                      const periodLabels = { '30': '30 дней', '60': '60 дней', '365': '1 год' };
                      const periodLabel = periodLabels[periodValue];
                      
                      if (periodLabel) {
                        return (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span 
                              style={{ 
                                fontWeight: 400,
                                fontSize: '10pt',
                              }}
                            >
                              {periodLabel}
                            </span>
                            
                            {/* Чекбокс для студента - правильный ли выбранный период (только в режиме студента, не в модалке) */}
                            {isChatPage && !isPharmacyModal && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: '10px' }}>
                                <input
                                  type="checkbox"
                                  checked={inputCheckboxStates[20] || false}
                                  onChange={() => handleInputCheckboxChange(20)}
                                />
                              </div>
                            )}
                          </div>
                        );
                      }
                    }
                    
                    // Если данных нет, показываем пустое место
                    return <span style={{ fontSize: '10pt' }}>Не указано</span>;
                  }
                  
                  // Для преподавателей (режим конструктора) показываем все варианты
                  return (
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isShow && (
                          <input
                            type="checkbox"
                            checked={inputCheckboxStates[17] || false}
                            onChange={() => handleValidityPeriodChange('30')}
                          />
                        )}
                        <span 
                          style={{ 
                            textDecorationThickness: '2px',
                            textDecorationColor: '#000',
                            textUnderlineOffset: '2px',
                            cursor: (isReadOnly && !isConstructor) ? 'default' : 'pointer',
                            fontSize: '10pt',
                          }}
                          onClick={() => handleValidityPeriodChange('30')}
                        >
                          30 дней
                        </span>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isShow && (
                          <input
                            type="checkbox"
                            checked={inputCheckboxStates[18] || false}
                            onChange={() => handleValidityPeriodChange('60')}
                          />
                        )}
                        <span 
                          style={{ 
                            textDecorationThickness: '2px',
                            textDecorationColor: '#000',
                            textUnderlineOffset: '2px',
                            cursor: (isReadOnly && !isConstructor) ? 'default' : 'pointer',
                            fontSize: '10pt',
                          }}
                          onClick={() => handleValidityPeriodChange('60')}
                        >
                          60 дней
                        </span>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isShow && (
                          <input
                            type="checkbox"
                            checked={inputCheckboxStates[19] || false}
                            onChange={() => handleValidityPeriodChange('1year')}
                          />
                        )}
                        <span 
                          style={{ 
                            textDecorationThickness: '2px',
                            textDecorationColor: '#000',
                            textUnderlineOffset: '2px',
                            cursor: (isReadOnly && !isConstructor) ? 'default' : 'pointer',
                            fontSize: '10pt',
                          }}
                          onClick={() => handleValidityPeriodChange('1year')}
                        >
                          1 год
                        </span>
                      </div>
                      
                      {/* Чекбокс правильности для выбранного варианта (только для преподавателя) */}
                      {isShow && (() => {
                        const hasSelectedPeriod = inputCheckboxStates[17] || inputCheckboxStates[18] || inputCheckboxStates[19];
                        return hasSelectedPeriod;
                      })() && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: '10px' }}>
                          <input
                            type="checkbox"
                            checked={inputCheckboxStates[20] || false}
                            onChange={() => handleInputCheckboxChange(20)}
                          />
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

            </div>
          </div>
      </div>
    </div>
  );
});

export default Form107_1; 